module.exports = __webpack_public_path__ + "img/up.cea392cc.svg";